var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.896447 0.646447C1.09171 0.451184 1.40829 0.451184 1.60355 0.646447L7.60355 6.64645C7.79882 6.84171 7.79882 7.15829 7.60355 7.35355L1.60355 13.3536C1.40829 13.5488 1.09171 13.5488 0.896447 13.3536C0.701184 13.1583 0.701184 12.8417 0.896447 12.6464L6.54289 7L0.896447 1.35355C0.701184 1.15829 0.701184 0.841709 0.896447 0.646447Z",
    fill: "#0F1125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRArrow);
export default __webpack_public_path__ + "static/media/r-arrow.1690ca2e14feb3ce3e8ae609b1537178.svg";
export { ForwardRef as ReactComponent };